import login from "./login";
import verifyToken from "./verifyToken";

export default {
  login,
  verifyToken
}